import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { assert } from '@sama/js-core';
import { isBooleanAttribute } from '../../../../../outputs/annotation/annotation-shared/utils/attribute-utils';
import { AttributeOption } from '../../../../../team-apis/otterdam/taxonomy';
import { AbstractAttributeInputComponent } from '../abstract-attribute-input-component';

@Component({
  selector: 'h3-boolean-attribute-input',
  templateUrl: './boolean-attribute-input.component.html',
  styleUrls: ['../abstract-attribute-input-component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BooleanAttributeInputComponent
  extends AbstractAttributeInputComponent
  implements OnInit
{
  options!: {
    true: AttributeOption;
    false: AttributeOption;
  };

  override ngOnInit() {
    assert(
      isBooleanAttribute(this.attribute),
      `Attribute ${this.attribute.name} is not a boolean attribute.`,
    );
    this.options = this.attribute.options;
    this.isReadOnly$ = this.store('readOnly').$;
    super.ngOnInit();
  }

  toggleInput(event: MatSlideToggleChange) {
    const option = event.checked ? this.options.true : this.options.false;
    this.setAttribute(option.value);
  }
}
